// extracted by mini-css-extract-plugin
export default {"staticIntro":"StaticIntro_staticIntro__pxQAX","text":"StaticIntro_text__AdY26"};